import {observable} from "mobx";
import http from 'libs/http';
import lodash from 'lodash'
import{addVisitLog, history} from 'libs';

class Store {
  @observable records = [];
  @observable hotRecords = [];
  @observable record = {};
  @observable recordId = 0;
  @observable isFetching = false;
  @observable keywords = null;
  @observable page = 1;
  @observable pageSize = 25;
  @observable pageTotal = 0;

  fetchRecords = (lang = 'zh') => {
    const submitData = {pageNo: this.page, pageSize: this.pageSize,param:{keywords:this.keywords}}
    addVisitLog({
      pageName: '产品列表',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "ProductList",
      eventName: "查看产品列表",
      content: JSON.stringify(submitData),
    })
    this.isFetching = true;
    // lang=en zh
    http.post('/javaApi/front/product/list',submitData)
      .then(res =>{
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows
      })
      .finally(() => this.isFetching = false)
  };

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    this.fetchRecords()
  }

  fetchHotRecords = () => {
    this.isFetching = true;
    http.get('/javaApi/front/product/getHotList?is_hot=' + this.recordId)
      .then(res => this.hotRecords = res.data.result)
      .finally(() => this.isFetching = false)
  }

  fetchRecord = (lang = 'zh') => {
    this.isFetching = true;
    return http.get('/javaApi/front/product/getDetail?id=' + this.recordId + '&lang=' + lang)
      .then(res => {
        this.record = res.data.result;
        addVisitLog({
          pageName: '产品详情页',
          fromPageUrl: window.referrerUrl,
          pageUrl:`${window.location.origin}${history.location.pathname}`,
          eventCode: "ProductDetail",
          eventName: "查看产品详情",
          content: JSON.stringify(res.data.result),
        })
      })
      .finally(() => this.isFetching = false)
  }
}

export default new Store()
